import { IUrl } from "@/interfaces/IUrl";
import api from "@/api/api-v1-config";

const url: IUrl = window as never;

// Define URLs
const URL_CHECK_AUTH = url.urls.checkAuth;
const URL_CHECK_REGISTERED = url.urls.checkRegistered;
const URL_LOGIN_GENERATE_CONFIRMATION_CODE =
	url.urls.loginGenerateConfirmationCode;
const URL_LOGOUT = url.urls.logout;

export async function checkAuthAxios() {
	return await api.get(URL_CHECK_AUTH);
}

/**
 * Проверяем, зарегистрирован номер или нет.
 * @param payload
 */
export async function checkRegisteredAxios(payload: { phone: string }) {
	return await api.post(URL_CHECK_REGISTERED, payload);
}

/**
 * Генерация проверочного кода
 * @param payload
 */
export async function loginGenerateConfirmationCodeAxios(payload: {
	phone: string;
}) {
	return await api.post(URL_LOGIN_GENERATE_CONFIRMATION_CODE, payload);
}

/**
 * Выход из системы
 */
export async function logoutAxios() {
	return await api.post(URL_LOGOUT);
}
